import { render, staticRenderFns } from "./productCode.vue?vue&type=template&id=d03b1616&"
import script from "./productCode.vue?vue&type=script&lang=js&"
export * from "./productCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports